export class PeriodicidadeService {
    

    getTiposPeriodoPersonalizado() {
        return [
            { label: 'Dia da semana', value: 'DIA' },
            { label: 'Mes do ano', value: 'MES' },
            { label: 'Dia do mês', value: 'DIA_MES' },
        ];
    }

    getTipoPeriodoPersonalizado(value: string) {
        return this.getTiposPeriodoPersonalizado().find(t => t.value === value);
    }

    getTiposPeriodo() {
        return [
            { label: 'Dias', value: 'DIA' },
            { label: 'Meses', value: 'MES' },
            { label: 'Anos', value: 'ANO' },
        ];
    }

    getTipoPeriodo(value: string) {
        return this.getTiposPeriodo().find(t => t.value === value);
    }

    getDiasSemana() {
        return [
            { label: 'Segunda-Feira', value: 'SEGUNDA' },
            { label: 'Terça-Feira', value: 'TERCA' },
            { label: 'Quarta-Feira', value: 'QUARTA' },
            { label: 'Quinta-Feira', value: 'QUINTA' },
            { label: 'Sexta-Feira', value: 'SEXTA' },
            { label: 'Sábado', value: 'SABADO' },
            { label: 'Domingo', value: 'DOMINGO' },
        ];
    }

    getMeses() {
        return [
            {label: 'Janeiro', value: 'JAN'},
            {label: 'Fevereiro', value: 'FEV'},
            {label: 'Março', value: 'MAR'},
            {label: 'Abril', value: 'ABR'},
            {label: 'Maio', value: 'MAI'},
            {label: 'Junho', value: 'JUN'},
            {label: 'Julho', value: 'JUL'},
            {label: 'Agosto', value: 'AGO'},
            {label: 'Setembro', value: 'SET'},
            {label: 'Outubro', value: 'OUT'},
            {label: 'Novembro', value: 'NOV'},
            {label: 'Dezembro', value: 'DEZ'},
        ]
    }

}